document.addEventListener('DOMContentLoaded', () => {
  // ***** LOGIC FOR MODAL ***** //
  const clinicalDataModal = document.querySelector('.clinical-data-modal-js');
  if (!clinicalDataModal) return;

  const openModalBtn = clinicalDataModal.querySelector("#clinicalDataModalOpenBtn");
  const closeModalBtn = clinicalDataModal.querySelector("#clinicalDataModalCloseBtn");
  const modal = clinicalDataModal.querySelector("#clinicalDataModal");

  // Open the modal when the button is clicked
  openModalBtn?.addEventListener("click", () => {
    modal.showModal();
  });

  // Close the modal when the close button is clicked
  closeModalBtn?.addEventListener("click", () => {
    modal.close();
  });

  // Close the modal when clicking outside the dialog (backdrop)
  modal?.addEventListener('click', (event) => {
    if (event.target === modal) {
      modal.close();
    }
  });


  // ***** LOGIC FOR TABS ***** //
  // Get all buttons and info elements
  const infoButtons = clinicalDataModal.querySelectorAll('.tabs__button-container--button');
  const infoElements = clinicalDataModal.querySelectorAll('.tabs__info');

  if (infoButtons && infoElements) {
    // Add click event listeners to buttons
    infoButtons.forEach((button, index) => {
      button.addEventListener('click', () => {
        // Remove the 'active' class from all buttons and info elements
        infoButtons.forEach((btn) => {
          btn.classList.remove('active');
        });
        infoElements.forEach((info) => {
          info.classList.remove('active');
        });

        // Add the 'active' class to the clicked button and corresponding info element
        button.classList.add('active');
        infoElements[index].classList.add('active');
      });
    });
    
    // Activate the first button on load
    infoButtons[0].click();
  }


  // ***** LOGIC FOR DESCRIPTION BUTTONS ***** //
  let descriptionButtons = clinicalDataModal.querySelectorAll('.show-description-btn-js');
  let descriptionElements = clinicalDataModal.querySelectorAll('.item-description-js');

  if (descriptionButtons && descriptionElements) {
    descriptionButtons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        if (btn.classList.contains('is-active')) {
          btn.classList.remove('is-active');
          descriptionElements.forEach(elem => {
            if (elem.dataset.itemName === btn.dataset.itemName) {
              elem.classList.remove('is-active');
            }
          });
        } else {
          btn.classList.add('is-active');
          descriptionElements.forEach(elem => {
            if (elem.dataset.itemName === btn.dataset.itemName) {
              elem.classList.add('is-active');
            }
          });
        }
      });
    });
  }

});